// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05adb390","732":"7a0c29da"}[chunkId] + ".chunk.js";
};